import type { Ref } from "vue";
import type { DSBaseListOption, DSOptionListModelValue } from "../types";
import { normalizeModelValue } from "@/src/design_system/form_elements/option_list/utils/optionListUtils";

export interface UseOptionListSelectionOptions {
  modelValue: Ref<DSOptionListModelValue | undefined>;
  multiple: Ref<boolean>;
  disabled: Ref<boolean>;
}

export const useOptionListSelection = ({ modelValue, multiple, disabled }: UseOptionListSelectionOptions) => {
  const selectOption = (option: DSBaseListOption) => {
    if (disabled.value) return;

    if (multiple.value) {
      const current = normalizeModelValue(modelValue.value);

      modelValue.value = current.includes(option.value)
        ? current.filter(value => value !== option.value)
        : [...current, option.value];

      return;
    }

    modelValue.value = option.value;
  };

  return { selectOption };
};
